import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CompanyGroup } from '@shared/entities/companyGroup';

@Component({
  selector: 'app-user-info-section',
  templateUrl: './user-info-section.component.html',
  styleUrl: './user-info-section.component.scss'
})
export class UserInfoSectionComponent {
  @Input() form!: FormGroup;
  @Input() isEdit = false;
  @Input() isLight = true;
  @Input() isCurrentUserAdmin = false;
  @Input() isAdminRole = false;
  @Input() companyGroups: CompanyGroup[] = [];
}
